<template>
    <div class="zs-sys-banner" :class="variantClass">
        <span class="zs-sys-banner__pulse" />
        <i :class="iconClass" />
        <span class="zs-sys-banner__msg" @click="$emit('messageClick')">
            <slot />
        </span>
        <div class="zs-sys-banner__spacer" />
        <div v-if="$slots.actions" class="zs-sys-banner__actions">
            <slot name="actions" />
        </div>
        <i v-if="dismissible" class="fa-solid fa-xmark" style="cursor: pointer" @click="$emit('dismiss')" />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        variant?: 'incident' | 'info';
        dismissible?: boolean;
    }>(),
    {
        variant: 'incident',
        dismissible: false
    }
);

defineEmits<{
    (e: 'dismiss'): void;
    (e: 'messageClick'): void;
}>();

const variantClass = computed(() => `zs-sys-banner--${props.variant}`);
const iconClass = computed(() => (props.variant === 'incident' ? 'fa-solid fa-triangle-exclamation' : 'fa-solid fa-circle-info'));
</script>
